module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA2NGMyNDcuNCAwIDQ0OCAyMDAuNiA0NDggNDQ4cy0yMDAuNiA0NDgtNDQ4IDQ0OFM2NCA3NTkuNCA2NCA1MTIgMjY0LjYgNjQgNTEyIDY0eiBtMCAxNjBhMzIgMzIgMCAwIDAtMzEuOCAyOC4zTDQ4MCAyNTZ2MjU2YzAgOC44IDMuNSAxNi43IDkuMyAyMi41bDMgMi43IDIuNiAyLjlMNjA4IDY1My4zYTMyIDMyIDAgMCAwIDQ3LjktNDIuMkw2NTMuMiA2MDggNTQ0IDQ5OC44VjI1NmEzMiAzMiAwIDAgMC0zMi0zMnoiIGZpbGw9IiMwIiBwLWlkPSI0MTUxIj48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Time-filled.svg
// module id = y2L9
// module chunks = 75